export default __webpack_public_path__ + "static/media/FRANK.6206b6cd.png";